import { useCallback, useReducer } from 'react';
import {
  initialSessionListControlsState,
  sessionListControlsReducer,
  SessionDateRange,
  SessionReviewFilter,
} from './dataTransformations';

const useSessionListControls = () => {
  const [state, dispatch] = useReducer(
    sessionListControlsReducer,
    initialSessionListControlsState,
  );

  const setSearchQuery = useCallback((value: string) => {
    dispatch({ type: 'setSearchQuery', value });
  }, []);

  const setDateRange = useCallback((value: SessionDateRange) => {
    dispatch({ type: 'setDateRange', value });
  }, []);

  const setSelectedSites = useCallback((value: string[]) => {
    dispatch({ type: 'setSelectedSites', value });
  }, []);

  const setSelectedReviewStates = useCallback((value: SessionReviewFilter[]) => {
    dispatch({ type: 'setSelectedReviewStates', value });
  }, []);

  const setCurrentPage = useCallback((value: number) => {
    dispatch({ type: 'setCurrentPage', value });
  }, []);

  const resetControls = useCallback(() => {
    dispatch({ type: 'reset' });
  }, []);

  return {
    ...state,
    setSearchQuery,
    setDateRange,
    setSelectedSites,
    setSelectedReviewStates,
    setCurrentPage,
    resetControls,
  };
};

export default useSessionListControls;
